export interface RuntimeConfig {
  REDIRECT_URI?: string;
  COGNITO_USER_POOL_ID?: string;
  COGNITO_CLIENT_ID?: string;
  COGNITO_REGION?: string;
  API_URL?: string;
  COGNITO_DOMAIN?: string;
  COGNITO_SCOPES?: string;
  COGNITO_ENDPOINT?: string;
  /** Comma-separated list of e-mail domains, e.g. `@quality24.com.br,@app.com.br` */
  PASSWORD_RESET_BLOCKED_DOMAINS?: string;
}

export const runtimeConfig =
  (window as unknown as Record<'runtimeConfig', RuntimeConfig>).runtimeConfig ||
  {};

export default runtimeConfig;
